import React from 'react';
import { useTranslation } from 'react-i18next';

import { REQUEST_STATUS } from '../../../../shared/api/hscan/hospital';
import {
  GreenStatusMessage,
  BlueStatusMessage,
  RedStatusMessage,
  Message,
} from '../../common/components/styledComponents';

interface StatusMessageProps {
  status: REQUEST_STATUS;
}
/**
 * 신청가능: available (G)
 * 신청완료: pending (B)
 * 발급완료: completed (B)
 * 발급실패: failed (R)
 * 발급거절: declined (R)
 * 발급취소: cancelled (R)
 */
export const StatusMessage = (props: StatusMessageProps) => {
  const { status } = props;
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.request.imageList.table.statusMessage',
  });

  switch (status) {
    case 'AVAILABLE':
      return <GreenStatusMessage>{`${t('available')}`}</GreenStatusMessage>;
    case 'PENDING':
      return <BlueStatusMessage>{`${t('pending')}`}</BlueStatusMessage>;
    case 'DECLINED':
      return <RedStatusMessage>{`${t('declined')}`}</RedStatusMessage>;
    case 'COMPLETED':
      return <BlueStatusMessage>{`${t('completed')}`}</BlueStatusMessage>;
    case 'FAILED':
      return <RedStatusMessage>{`${t('failed')}`}</RedStatusMessage>;
    case 'FAILED':
      return <RedStatusMessage>{`${t('cancelled')}`}</RedStatusMessage>;
    default:
      return <Message>{status}</Message>;
  }
};
